import { useApiModel } from '@hooks/use-api-model';
import { useApiSubmit } from '@hooks/use-api-submit';
import { DashRegistrationStep } from '@/types/dashboard';
import { defaultScreeningProgress } from '@/types/screening/screening-progress';
import type { IScreeningSummaryModel, IScreeningSummarySubmitResult } from '@/types/screening/screening-summary';

const SCREENING_Summary_ENDPOINT = '/api/register/screening-summary';

const defaultScreeningSummaryModel: IScreeningSummaryModel = {
    ...defaultScreeningProgress,
    currentRegistrationStep: DashRegistrationStep.ScreeningSummary,

    isQuickStartDonor: false,
    siteName: '',
    recipientCenter: '',
    recipientCenterDisplay: '',
    isDcnSite: false,
    isNkrSite: false,
    isRdnCenter: false,

    firstName: '',
    lastName: '',
    phoneNumber: '',
    phoneNumberSecondary: '',
    postalCode: '',
    genderText: '',
    birthDateText: '',
    heightFeet: 0,
    heightInches: 0,
    weightLbs: null,
    isResidingInUsa: null,
    isAbleToGetToUsa: null,
    isCurrentlyIncarcerated: null,

    countryOfResidenceText: '',
    addressLine1: '',
    city: '',
    stateProvince: '',
    ethnicityText: '',
    hasSsn: false,
    ssnMasked: '',
    dlIssueCountryText: '',
    dlIssueStateText: '',
    dlNumber: '',
    mothersMaidenName: '',
    preferredLanguageText: '',
    contactPreferenceText: '',
    contactBestHoursText: '',
    emergencyContact: '',
    emergencyContactPhone: '',
    emergencyContactRelationshipText: '',
    maritalStatusText: '',
    employmentStatusText: '',
    occupation: '',
    occupationHasHeavyLifting: null,
    exerciseRoutineText: '',
    hasHealthInsurance: null,
    physicianName: '',
    physicianCity: '',
    physicianStateText: '',
    motivationToDonate: '',

    willAcceptTransfusions: null,
    hasNutcracker: null,
    hasHadKidneyDisease: null,
    hasHadHeartAttack: null,
    heartAttackRemissionText: '',
    hasDiabetes: null,
    diabetesStatusText: '',
    hasHadCancer: null,
    cancers: '',
    hasHadKidneyStones: null,
    kidneyStoneEpisodesText: '',
    kidneyStoneRemissionText: '',
    kidneyStoneTreatmentText: '',
    hasBeenPregnant: null,
    hadGestationalDiabetes: null,
    isPregnant: null,
    monthsSincePregnant: 0,
    isNursing: null,
    hasUsedTobacco: null,
    usesTobacco: null,
    willStopTobaccoUse: null,
    hasHivText: '',

    donorSituationText: '',
    isDirectedDonor: false,
    ddRelationshipText: '',
    recipientName: '',
    knowsRecipientDob: null,
    recipientDobText: '',
    recipientCenterId: null,
    recipientAtSameDashCenter: null,
    recipientIsWillingToTransfer: null,
    isRemoteDonationPreferred: null,
    isHardshipToTravel: null,
    whyNotRemote: '',
};

export const useScreeningSummary = (registrationId: number, editKey: string) => {
    const url = `${SCREENING_Summary_ENDPOINT}/${registrationId}/${editKey}`;

    const { model, isLoading, error } = useApiModel(url, defaultScreeningSummaryModel);

    const { submit, isSubmitting, submitError } = useApiSubmit<void, DashRegistrationStep, IScreeningSummarySubmitResult>(
        url,
        () => ({}),
        (nextStep) => ({ nextStep }),
    );

    return { model, isLoading, error, submit, isSubmitting, submitError };
};
